<template>
  <div class="p-question-detail">
    <CommonHeader :pinned="true" class="common-header">
      {{ $t("question.detail") }}
      <span slot="right">
        <svg class="m-style-svg m-svg-def" @click="onMoreClick">
          <use xlink:href="#icon-more" />
        </svg>
      </span>
    </CommonHeader>

    <div class="container">
      <div v-if="loading && !question.id" class="m-pos-f m-spinner" />
      <JoLoadMore
        ref="loadmore"
        :auto-load="false"
        @onRefresh="fetchQuestion"
        @onLoadMore="onLoadMore"
      >
        <!-- Main -->
        <div class="main">
          <!-- Topics -->

          <!-- Title -->
          <h3 class="main-title">{{ question.subject }}</h3>
          <div class="main-topics">
            <span v-for="topic in tags" :key="topic.id" class="label">{{
              topic.name
            }}</span>
          </div>

          <!-- <div class="main-topics">
            <RouterLink
              v-for="topic in topics"
              :key="topic.id"
              :to="`/question-topics/${topic.id}`"
              class="label"
            >
              {{ topic.name }}
            </RouterLink>
          </div>-->
          <!-- author -->
          <div class="main-author">
            <div>
              <Avatar :user="user" size="nano" :anonymity="!user.name" />&nbsp;
              <span>{{ username }}</span>
            </div>
            <div>{{ question.created_at | time2tips }}</div>
          </div>

          <!-- Body -->
          <div
            class="markdown-body"
            @click="toggleBody"
            v-html="showmore ? htmlBody : htmlWithoutTag"
          />
          <span
            v-if="htmlWithoutTag.length > 63"
            class="body-toggle"
            :class="{ 'show-less': showmore }"
            @click="toggleBody"
          >
            <!-- {{ showmore?'收起':'...显示更多' }} -->
          </span>
          <div v-if="invitations.length" class="invitations-list">
            <span
              v-for="invitation in invitations"
              :key="invitation.id"
              @click="userDetail(invitation)"
              >@{{ invitation.name }}</span
            >
          </div>
          <!-- <div v-if="images.length" class="m-images">
            <AsyncFile
              v-for="img in images"
              v-if="img"
              :key="img"
              :file="getImgId(img)"
            >
              <img
                v-if="props.src"
                slot-scope="props"
                class="c-img"
                :src="props.src"
              >
            </AsyncFile>
          </div> -->

          <!-- attach -->
          <div
            v-for="attachment in question.attachments"
            v-if="question.attachments"
            :key="attachment.id"
            class="m-attach"
          >
            <div class="m-attach__file m-box" @click="downloadFile(attachment)">
              <attachment-type :name="attachment.file.origin_filename" />
              <span class="m-attach__filename">{{
                attachment.file.origin_filename
              }}</span>
            </div>
          </div>

          <!-- watch -->
          <div class="main-watch">
            <div class="main-watch-count">
              <span class="follow-count"
                >{{ question.watchers_count }}
                {{ $t("follow.name") }}&nbsp;&nbsp;{{
                  question.views_count
                }}人浏览</span
              >
              <div v-if="question.amount" class="shang split">
                <span>{{ $t("article.badge.reward") }}</span>
                {{ question.amount }} 金豆
              </div>
              <span v-if="onlookersTotal" class="shang split">
                <span>{{ $t("article.badge.onlook") }}</span>
                {{ onlookersTotal }}
              </span>
            </div>

            <!-- Watch question button -->
            <button
              v-if="question.watched"
              class="main-watch-follow active"
              @click="handleUnwatch"
            >
              <svg class="m-style-svg follow-btn">
                <use xlink:href="#icon-yes" />
              </svg>
              {{ $t("follow.already") }}
            </button>
            <button v-else class="main-watch-follow" @click="handleWatch">
              <svg class="m-style-svg follow-btn">
                <use xlink:href="#icon-plus" />
              </svg>
              {{ $t("follow.name") }}
            </button>
          </div>
        </div>

        <!-- Button -->
        <div class="main-button">
          <div class="button" @click="onRewardClick">
            <svg class="main-button-icon" fill="#666">
              <use
                :xlink:href="
                  `#icon-question-${question.amount ? 'reward' : 'unreward'}`
                "
              />
            </svg>
            <template v-if="invitations.length && +question.amount">{{
              $t("question.answer.invite[0]")
            }}</template>
            <template v-else-if="invitations.length && !+question.amount">{{
              $t("question.answer.invite[1]")
            }}</template>
            <template v-else-if="!invitations.length && +question.amount">
              {{ $t("question.answer.invite[2]") }}
            </template>
            <template v-else>
              {{ $t("question.answer.invite[3]") }}
            </template>
          </div>

          <div v-if="question.my_answer" class="button" @click="gotoMyAnswer">
            {{ $t("question.answer.view") }}
          </div>
          <div v-else class="button" @click="addAnswer">
            <svg class="main-button-icon" fill="#666">
              <use xlink:href="#icon-question-add" />
            </svg>
            {{ $t("question.answer.add") }}
          </div>
        </div>

        <!-- Answers -->
        <div v-if="answers.length" class="answers-tool">
          <div>{{ question.answers_count | t("question.answer.count") }}</div>
          <button @click="showOrderPopup">
            {{
              answersTimeOrder
                ? "question.answer.sort[0]"
                : "question.answer.sort[1]" | t
            }}
            <svg fill="#999" class="icon">
              <use xlink:href="#icon-list" />
            </svg>
          </button>
        </div>

        <!-- Answer list -->
        <QuestionAnswerCard
          v-for="answer in answers"
          :key="answer.id"
          :answer="answer"
          :allow-adopt="allowAdopt(answer)"
          @update:answer="val => updateAnswer(val)"
        />
      </JoLoadMore>
    </div>

    <!-- <footer ref="foot" class="m-pos-f">
      <a class="m-box-model m-aln-center" @click.prevent="handleShare">
        <svg class="m-style-svg m-svg-def">
          <use xlink:href="#ico_share" />
        </svg>
        <span>{{ $t('share') }}</span>
      </a>
      <a class="m-box-model m-aln-center" @click.prevent="handelComment">
        <svg class="m-style-svg m-svg-def">
          <use xlink:href="#ico_comment" />
        </svg>
        <span>{{ $t('comment.name') }}</span>
      </a>
      <a class="m-box-model m-aln-center" @click.prevent="onMoreClick">
        <svg class="m-style-svg m-svg-def">
          <use xlink:href="#icon-more" />
        </svg>
        <span>{{ $t('more') }}</span>
      </a>
    </footer> -->
  </div>
</template>

<script>
import _ from "lodash";
import { render } from "@/util/markdown";
import * as api from "@/api/question/questions";
import { listByDefault, listByTime } from "@/api/question/answer";
import QuestionAnswerCard from "./components/QuestionAnswerCard";
import AttachmentType from "@/components/common/AttachmentType.vue";
import FileSaver from "file-saver";
import wechatShare from "@/util/wechatShare";

export default {
  name: "QuestionDetail",
  components: {
    AttachmentType,
    QuestionAnswerCard
  },
  data() {
    return {
      question: {},
      answersTimeOrder: false,
      answers: [],
      loading: true,
      showmore: true
    };
  },
  computed: {
    questionId() {
      return Number(this.$route.params.questionId);
    },
    /**
     * The loged user.
     *
     * @return {Object}
     * @author Seven Du <shiweidu@outlook.com>
     */
    logedUser() {
      const { CURRENTUSER: user } = this.$store.state;
      return user;
    },

    /**
     * The loged user is deiter?
     *
     * @return {boolean}
     * @author Seven Du <shiweidu@outlook.com>
     */
    editer() {
      // 请不要删除，目前暂时不需要管理员可修改问题。
      // 后续需要增加的功能。
      // const { roles = [] } = this.logedUser;
      // for (let index in roles) {
      //   let role = roles[index];
      //   if (role.name === 'founder') {
      //     return true;
      //   }
      // }

      return false;
    },
    user() {
      return this.question.user || {};
    },
    images() {
      return this.question.image || [];
    },
    topics() {
      return this.question.topics || [];
    },
    tags() {
      return this.question.tags || [];
    },
    isMine() {
      return this.logedUser.id === this.question.user_id;
    },
    htmlWithoutTag() {
      const { body = "" } = this.question;
      return render(body)
        .replace(/<[^>]*>|<\/[^>]*>/gm, "")
        .slice(0, 64);
    },
    htmlBody() {
      const { body = "" } = this.question;
      return render(body);
    },
    answerRequestMethod() {
      return this.answersTimeOrder ? listByTime : listByDefault;
    },
    invitations() {
      return this.question.invitations || [];
    },
    adoptionAnswers() {
      return this.question.adoption_answers || [];
    },
    invitationAnswers() {
      return this.question.invitation_answers || [];
    },
    onlookersTotal() {
      return this.invitationAnswers
        .map(item => Number(item.onlookers_total))
        .reduce((a, b) => a + b, 0);
    },
    username() {
      if (!this.user.name) return "匿名用户";
      let name = this.user.name;
      if (this.question.anonymity) name += "(匿名)";
      return name;
    },
    excellent: {
      get() {
        return this.question.excellent === 1;
      },
      set(val) {
        return (this.question.excellent = val);
      }
    }
  },
  watch: {
    answersTimeOrder(newRoute, oldRoute) {
      if (newRoute.path === oldRoute.path) {
        this.answers = [];
        this.$refs.loadmore.beforeRefresh();
      }
    }
  },
  created() {
    this.fetchQuestion();
  },
  methods: {
    toUrl(img) {
      return process.env.VUE_APP_API_HOST + img;
    },
    fetchQuestion() {
      this.loading = true;
      api.show(this.questionId).then(({ data }) => {
        this.loading = false;
        this.question = data;
        document.title = this.question.subject;
        this.onRefresh();
        const shareUrl =
          window.location.origin +
          process.env.BASE_URL.substr(0, process.env.BASE_URL.length - 1) +
          this.$route.fullPath;
        const signUrl =
          this.$store.state.BROWSER.OS === "IOS" ? window.initUrl : shareUrl;

        this.$store.state.BROWSER.isWechat &&
          wechatShare(signUrl, {
            title: this.question.subject,
            desc: this.question.text_body,
            link: shareUrl
          });
      });
    },
    onRefresh() {
      if (!this.questionId) return this.$refs.loadmore.afterRefresh();
      this.answerRequestMethod(this.questionId).then(({ data }) => {
        let answers = data;
        // this.answers = data
        // mixin adoption answers
        answers.unshift(...this.adoptionAnswers);
        // mixin invitation answers
        answers.unshift(...this.invitationAnswers);
        var obj = [];
        answers = answers.reduce((pre, cur) => {
          if (obj.indexOf(cur.id) > -1) return pre;
          obj.push(cur.id);
          return [...pre, cur];
        }, []);
        this.answers = answers;
        this.$refs.loadmore.afterRefresh(data.length < 15);
      });
    },
    onLoadMore() {
      if (!this.answers.length) return;
      this.answerRequestMethod(this.questionId, this.answers.length)
        .then(({ data }) => {
          this.$refs.loadmore.afterLoadMore(data.length < 15);
          this.answers.push(...data);
        })
        .catch(({ response: { data } = {} }) => {
          this.$refs.loadmore.afterLoadMore(true);
          this.$Message.error(data);
        });
    },
    downloadFile({ id, file }) {
      if (/.(png|jpg|jpeg|pdf)$/.test(file.filename)) {
        return window.open(`${this.$http.defaults.baseURL}/files/${id}`);
      }
      this.$http
        .get(`/files/${id}?json=1`, {
          validateStatus: s => s === 200
        })
        .then(res => {
          FileSaver.saveAs(res.data.url, file.origin_filename);
        });
    },
    handelComment() {
      this.$router.push({
        name: "QuestionComments",
        params: { questionId: this.question.id }
      });
    },
    handleWatch() {
      api
        .watch(this.questionId)
        .then(() => {
          this.question.watched = true;
          this.question.watchers_count += 1;
        })
        .catch(({ response: { data } = {} }) => {
          this.$Message.error(data);
        });
    },
    handleUnwatch() {
      api
        .unwatch(this.questionId)
        .then(() => {
          this.question.watched = false;
          this.question.watchers_count -= 1;
        })
        .catch(({ response: { data } = {} }) => {
          this.$Message.error(data);
        });
    },
    allowAdopt(answer) {
      // !this.question.adoption_answers.length &&
      return answer.adoption === 0 && this.isMine;
    },
    addAnswer() {
      setTimeout(() => {
        this.$router.push({ path: `/question/${this.questionId}/answers/add` });
      }, 300);
    },
    gotoMyAnswer() {
      const {
        my_answer: { id = "" }
      } = this.question;
      this.$router.push({
        path: `/questions/${this.question.id}/answers/${id}`
      });
    },
    showOrderPopup() {
      const actions = [
        {
          text: this.$t("question.answer.sort[0]"),
          method: () => {
            this.answersTimeOrder = true;
          }
        },
        {
          text: this.$t("question.answer.sort[1]"),
          method: () => {
            this.answersTimeOrder = false;
          }
        }
      ];
      this.$bus.$emit("actionSheet", actions);
    },
    onMoreClick() {
      const actions = [];
      // actions.push({
      //   text: this.$t('comment.name'),
      //   method: () => {
      //     this.$router.push({ name: 'QuestionComments', params: { questionId: this.question.id } })
      //   },
      // })
      actions.push({
        text: this.$t("share"),
        method: () => {
          this.$Message.info(this.$t("article.share_brownser"));
        }
      });
      actions.push({
        text: this.$t("release.repost"),
        method: () =>
          this.$router.push({
            name: "Repost",
            query: {
              repost_id: this.question.id,
              repost_type: "questions"
            }
          })
      });
      if (this.isMine) {
        !this.excellent &&
          actions.push({
            text: this.$t("question.excellent.apply"),
            method: () => {
              api.applyExcellentQuestion(this.question.id).then(({ data }) => {
                this.excellent = 1;
                this.$Message.success(data);
              });
            }
          });
        if (!this.answers.length) {
          actions.push({
            text: this.$t("edit"),
            method: () => {
              this.$router.push({
                name: "QuestionEdit",
                params: { questionId: this.question.id }
              });
            }
          });

          actions.push({
            text: this.$t("delete.name"),
            method: () => {
              api.deleteQuestion(this.question.id).then(() => {
                this.$router.go(-1);
              });
            }
          });
        }
      } else {
        actions.push({
          text: this.$t("report.name"),
          method: () => {
            this.$bus.$emit("report", {
              type: "question",
              payload: this.question.id,
              username: this.question.anonymity
                ? this.$t("profile.anonymity")
                : this.question.user.name,
              reference: this.question.subject
            });
          }
        });
      }
      this.$bus.$emit("actionSheet", actions);
    },
    updateAnswer(answer) {
      this.answers = _.unionBy([answer], this.answers, "id");
    },
    onRewardClick() {
      if (this.invitations.length) {
        // TODO 邀请悬赏页面
      } else if (this.isMine) {
        if (!this.question.amount) {
          this.$router.push({
            name: "QuestionReward",
            params: { questionId: this.question.id }
          });
        }
      }
    },
    toggleBody() {
      // this.showmore = !this.showmore
    },
    handleShare() {
      if (this.isWechat) {
        this.$Message.info(this.$t("article.share_wechat"));
      } else {
        this.$Message.info(this.$t("article.share_brownser"));
      }
    },
    getImgId(img) {
      const imgs = img.split("/");
      const length = imgs.length;
      return +imgs[length - 1];
    },
    userDetail(item) {
      this.$router.push({
        path: `/users/${item.id}/bio`
      });
    }
  }
};
</script>

<style lang="less" scoped>
.p-question-detail {
  position: relative;
  padding-bottom: 100px;
  .tabbar {
    position: fixed;
    z-index: 1;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 94px;
    width: 100%;
    background-color: #fff;
    bottom: 0;
    border-top: solid 1px #d7d8d8; /* no */

    @media screen and (min-width: 769px) {
      width: 768px;
    }

    .tabbar-item {
      flex-grow: 1;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #999;
      font-size: 12px;
    }

    .tabbar-icon {
      width: 32px;
      height: 32px;
      margin-bottom: 6px;
    }
  }

  .main {
    background-color: #fff;
    padding: 30px;
    width: 100%;
    max-width: 100%;
    height: auto;

    .main-topics {
      width: 100%;
      height: auto;

      > .label {
        display: inline-block;
        background-color: #e5f7fe;
        border-radius: 20px;
        font-size: 24px;
        color: @primary;
        padding: 6px 15px;
        margin-right: 14px;
        margin-bottom: 14px;
        white-space: nowrap;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
    }

    .main-title {
      font-size: 36px;
      color: #333;
      font-weight: normal;
      line-height: 1.4;
      margin: 12px 0;
    }

    .main-author {
      display: flex;
      align-items: center;
      margin-bottom: 22px;
      font-size: 80%;
      color: #ccc;
      width: 100%;
      justify-content: space-between;
    }
    .markdown-body {
      display: inline;
      &::after {
        display: inline;
      }
      * {
        word-break: break-all;
      }
    }
    .show-less {
      // position: absolute;
      // float: right;
      display: inline;
      margin-bottom: 40px;
    }
    .body-toggle {
      display: inline;
      color: #3283a2;
    }
    .m-images {
      word-break: break-all;
      margin: 20px 0;
      img {
        width: 100%;
        max-width: 100%;
      }
    }

    .main-watch {
      width: 100%;
      font-size: 26px;
      color: #999;
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .main-watch-follow {
        height: 50px;
        width: 5.5em;
        padding: 0;
        border: solid 2px @primary;
        border-radius: 8px;
        background-color: #fff;
        color: @primary;
        font-size: 26px;
        line-height: 5px;
        outline: none;

        > span {
          width: 20px;
          height: 20px;
          font-size: 36px;
          margin-right: 2px;
          vertical-align: middle;
        }

        .follow-btn {
          color: @primary;
          width: 20px;
          height: 20px;
          vertical-align: baseline;
        }

        &.active {
          color: #ccc;
          border: solid 2px #ccc;

          .follow-btn {
            color: #ccc;
          }
        }
      }
      .main-watch-count {
        .split::before {
          content: "·";
          margin: 0 12px;
          color: @text-color3;
        }

        .shang {
          color: @warning;
          display: inline-block;
          > span {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            height: 34px;
            width: 34px;
            border: solid 1px currentColor; /* no */
            border-radius: 4px;
            font-size: 22px;
          }
        }
      }
    }
  }

  .main-button {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    border-top: solid 1px #ededed; /* no */
    font-size: 28px;
    background-color: #fff;
    padding: 30px 0;

    > .button {
      flex: auto;
      text-align: center;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      color: #666;
      border-right: 1px solid #ededed; /* no */

      &:last-child {
        border-right: none;
      }
    }

    .main-button-icon {
      width: 30px;
      height: 30px;
      margin-top: -2px;
      margin-right: 20px;
    }
  }

  .answers-tool {
    background: @gray-bg;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    color: #999;
    padding: 25px 27px;

    > button {
      background-color: transparent;
      outline: none;
      color: #999;

      > .icon {
        width: 30px;
        height: 30px;
        margin-bottom: -6px;
        margin-left: 14px;
      }
    }
  }
  .common-header {
    color: #fff;
    background-color: @tool-bar-bg;
  }
  .m-pos-f {
    display: flex;
    width: 750px;
    justify-content: space-around;
    height: 94px;
    font-size: 22px;
    background-color: #1a1a1a;
    align-items: center;
    top: auto;
    a {
      color: #fff;
    }
    .footer-img {
      width: 30px;
      margin-bottom: 5px;
    }
  }
  .m-attach {
    width: 100%;
    margin-top: 20px;
    &__file {
      flex-basis: 100%;
      margin-top: 20px;
    }
    &__filename {
      display: inline-block;
      font-size: 28px;
      margin-left: 20px;
      flex-grow: 1;
      word-break: break-all;
    }
  }
}
.invitations-list {
  margin-top: 10px;
  color: #00aeef;
  font-size: 30px;
  > span {
    margin-right: 10px;
  }
}
</style>

<style scoped>
.markdown-body >>> p {
  display: inline;
}
</style>
